<template>
<section>
  <parallax-contact-us data-aos="fade"></parallax-contact-us>
  </section>
</template>

<script>
import ParallaxContactUs from "../components/ParallaxContactUs";
export default {
  components: {
    ParallaxContactUs
  }
};
</script>

<style>
</style>